import React from 'react'

import { RanContext } from './ran-context'

export default (Component) => {
  return function ConfigComponent(props) {
    return (
      <RanContext.Consumer>
        {rooms => <Component {...props} {...rooms} />}
      </RanContext.Consumer>
    )
  }
}
